export default {
  LOGIN: 'login',
  SIGN_UP: 'signup',
};



// WEBPACK FOOTER //
// ./src/shared/constants/request-login-modes.js